import { MapContainer, TileLayer, Marker, useMapEvents, useMap, Popup } from 'react-leaflet';
import { useEffect } from 'react';
import 'leaflet/dist/leaflet.css';
import pin from '../../assets/img/marker.svg';
import L from 'leaflet';

// Map hajmini to'g'irlash uchun komponent
function FixMap() {
    const map = useMap();
    useEffect(() => {
        const timer = setTimeout(() => map.invalidateSize(), 200);
        return () => clearTimeout(timer);
    }, [map]);
    return null;
}

// Click handler - alohida komponent
function ClickHandler({ position, setPosition }) {
    const map = useMap();
    useMapEvents({
        click(e) {
            setPosition([e.latlng.lat, e.latlng.lng]);
        }
    });
    useEffect(() => {
        if (position) {
            map.flyTo(position, map.getZoom(), { duration: 1.5 });
        }
    }, [position, map]);
    return null;
}

// Marker icon - komponent tashqarisida (har renderda qayta yaratilmaydi)
const markerIcon = L.icon({
    iconUrl: pin,
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40],
});

export default function ClickMarker({ position, setPosition, height = '200px', center }) {
    return (
        <MapContainer
            center={center || position}
            zoom={14}
            whenCreated={(map) => {
                if (center) {
                    map.flyTo(center, 15);
                }
            }}
            style={{ height: height, width: '100%' }}
        >
            <FixMap />
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; CYBER AREA UZB"
            />
            <ClickHandler position={position} setPosition={setPosition} />
            <Marker position={position} icon={markerIcon}>
                <Popup>Marker</Popup>
            </Marker>
        </MapContainer>
    );
}
